var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ButtonAFY, ModalComponentAFY, sizes, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useStyles } from "./style";
export var ModalConfirmationDelete = function (props) {
    var classes = useStyles();
    return (_jsx(ModalComponentAFY, __assign({ openModal: props.openModal, backgroundColor: "#ffffff", onClose: function () {
            props.setOpenModal(false);
        }, border: 0, minWidthModal: "500px", padding: 30 }, { children: _jsxs("div", __assign({ style: { marginTop: "10px" } }, { children: [_jsx("h2", __assign({ className: classes.title }, { children: "Eliminar ".concat(props.titleDelete) })), _jsx("p", __assign({ className: classes.description }, { children: "\u00BFEst\u00E1 seguro que desea eliminar ".concat(props.subTitleDelete, "?") })), _jsxs("div", __assign({ className: classes.buttonsContainer }, { children: [_jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "No", backgroundColor: "red", onClick: function () {
                                    props.setOpenModal(false);
                                } }) })), _jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Si, eliminar", onClick: function () {
                                    if (props.titleDelete === "recurrencia de pago") {
                                        props.deleteRecurrence();
                                    }
                                    else {
                                        props.deletePaymentMode();
                                    }
                                } }) }))] }))] })) })));
};
